import { muiComponentsBaseline } from './muiComponents/muiComponentsBaseline'
import { muiComponentsButtonVariants } from './muiComponents/muiComponentsButtonVariants'
import { contextButtonVariants } from './muiComponents/muiComponentsContextButtonVariants'
import { contextConnectedVariant } from './muiComponents/muiComponentsContextConnectedVariant'
import { muiComponentsMenus } from './muiComponents/muiComponentsMenus'
import { muiComponentsForms } from './muiComponents/muiComponentsForms'
import { muiComponentsMisc } from './muiComponents/muiComponentsMisc'

const components = {
  ...muiComponentsBaseline,
  ...muiComponentsMenus,
  ...muiComponentsForms,
  ...muiComponentsMisc,
  MuiButton: {
    ...muiComponentsBaseline.MuiButton,
    variants: [
      ...muiComponentsButtonVariants.MuiButton.variants,
      ...contextButtonVariants,
      contextConnectedVariant,
    ],
  },
}

export default components
